// External packages
import React from 'react';

// Utils
import { twMerge } from 'tailwind-merge';

export const TableContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => {
  return (
    <div
      {...props}
      className={twMerge(
        'relative max-h-100 max-w-full overflow-auto rounded-lg border border-gray-200 bg-gray-200',
        className
      )}
    />
  );
};

export const Table: React.FC<React.TableHTMLAttributes<HTMLTableElement>> = ({
  className,
  ...props
}) => {
  return (
    <table
      {...props}
      className={twMerge('w-full bg-white', className as string)}
    />
  );
};

export const TableHeader: React.FC<
  React.HTMLAttributes<HTMLTableSectionElement>
> = ({ className, ...props }) => {
  return (
    <thead
      {...props}
      className={twMerge(
        'sticky top-0 rounded-lg [&_tr]:!bg-gray-200 whitespace-nowrap text-gray-500 [&_th]:font-semibold',
        className as string
      )}
    />
  );
};

export const TableBody: React.FC<
  React.HTMLAttributes<HTMLTableSectionElement>
> = ({ className, ...props }) => {
  return (
    <tbody
      {...props}
      className={twMerge(
        'data-empty:h-20 data-empty:text-center data-empty:italic',
        className as string
      )}
    />
  );
};

export const Row: React.FC<React.HTMLAttributes<HTMLTableRowElement>> = ({
  className,
  ...props
}) => {
  return (
    <tr
      {...props}
      className={twMerge(
        'border-b border-gray-200 last:border-0 odd:bg-gray-50 data-selected:text-blue-600',
        className as string
      )}
    />
  );
};

export const Column: React.FC<
  React.ThHTMLAttributes<HTMLTableCellElement> & {
    allowsSorting?: boolean;
    sortDirection?: 'ascending' | 'descending';
  }
> = ({ className, children, allowsSorting, sortDirection, ...props }) => {
  return (
    <th
      {...props}
      className={twMerge(
        'px-4 py-2 text-start font-normal',
        className as string
      )}
    >
      {children}
      {allowsSorting && (
        <span aria-hidden="true" className="sort-indicator ml-1">
          {sortDirection && (sortDirection === 'ascending' ? '▲' : '▼')}
        </span>
      )}
    </th>
  );
};
